module.exports = __webpack_public_path__ + "img/test.631d2c4.svg";